import { useEffect } from 'react'
import { useOversamplingStore } from './store.ts'

export function OversamplingControl() {
  const { oversampling, setOversampling } = useOversamplingStore()

  useEffect(() => {
    setOversampling(oversampling)
  }, [])

  return (
    <div className="flex gap-2 items-center">
      <span className="text-[#888] w-16 text-right">OS:</span>
      <div className="grid grid-cols-2 gap-1">
        {([1, 2, 4, 8] as const).map(factor => (
          <button
            key={factor}
            onClick={() => setOversampling(factor)}
            className={`px-3 py-1 text-sm font-semibold rounded-md border ${
              oversampling === factor
                ? 'bg-gradient-to-br from-orange-600 to-orange-500 border-orange-400 text-white'
                : 'bg-gradient-to-br from-neutral-900 to-neutral-700 border-neutral-600 text-neutral-300'
            }`}
          >
            x{factor}
          </button>
        ))}
      </div>
    </div>
  )
}

